import { Card } from 'antd';
import styled from 'styled-components';

const ProductsTabBarWrapper = styled.div`
  && {
    .ant-tabs-tab {
      border-radius: 5px !important;
      background-color: #ffffff !important;
    }

    .ant-tabs-nav::before {
      content: none !important;
      position: none;
    }

    .ant-tabs-tab {
      color: #808080;
      padding: 6px 30px !important;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      background: var(--color-fill-alter) !important;
      border: 1px solid var(--color-primary) !important;
    }

    .ant-tabs-nav {
      margin: 0px;
    }
  }
`;

const PaymentTabBarWrapper = styled.div`
  && {
    .ant-tabs-tab {
      display: flex;
      justify-content: center;
      margin: 0px !important;
      border-bottom: 1px solid #e6e6e6;
      width: 150px;
    }

    .ant-tabs-ink-bar {
      display: none;
    }

    .ant-tabs-tab-active {
      background-color: var(--color-primary);

      .ant-tabs-tab-btn {
        color: #ffffff !important;
      }
    }
  }
`;

const { Meta } = Card;

const CardWrapper = styled(Card)`
  && {
    margin-top: 25px;
    border: none;
    box-shadow: 0px 2px 6px #0000001a;

    .ant-card-body {
      padding: 0px;
    }
  }
`;

const MetaWrapper = styled(Meta)`
  && {
    padding: 11px;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    margin-top: 0.1%;
  }
`;

const renderTabBarProducts = (props, DefaultTabBar) => {
  return (
    <ProductsTabBarWrapper>
      <DefaultTabBar {...props} />
    </ProductsTabBarWrapper>
  );
};

const renderTabBarPayment = (props, DefaultTabBar) => {
  return (
    <PaymentTabBarWrapper {...props}>
      <DefaultTabBar {...props} />
    </PaymentTabBarWrapper>
  );
};

export { renderTabBarPayment, renderTabBarProducts, CardWrapper, MetaWrapper };
